import { ProductCategoryJoinInfoDto } from 'src/types/generated';

import BaseReadApiModule from 'src/api/baseRead';

class ProductCategoryApi extends BaseReadApiModule<ProductCategoryJoinInfoDto> {
  protected baseRoute = '/product-categories';
}

export default ProductCategoryApi;
